export const carouselItems = [
  {
    id: 1,
    title: '2026暑期档热播大剧专题',
    subtitle: '全网首播 · 每日更新',
    description: '集结今年最受期待的暑期大剧，《长安十二时辰2》《大江大河4》《风起陇西2》等年度巨制，带你领略国产剧巅峰品质。',
    tag: '暑期档',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20series%20poster%20with%20ancient%20palace%20silhouette%20and%20warm%20golden%20lighting%2C%20cinematic%20composition%2C%20dramatic%20atmosphere%2C%20rich%20amber%20tones%2C%20movie%20poster%20style%20with%20Chinese%20calligraphy&width=800&height=450&seq=carousel-01&orientation=landscape',
  },
  {
    id: 2,
    title: '悬疑推理剧场 · 烧脑合集',
    subtitle: '高能反转 · 口碑佳作',
    description: '年度最烧脑悬疑剧集一网打尽，《白夜追凶3》《隐秘的角落2》《沉默的真相》姊妹篇，每部都是豆瓣8.5+神作。',
    tag: '悬疑',
    image: 'https://readdy.ai/api/search-image?query=Dark%20mystery%20thriller%20drama%20visual%20with%20shadowy%20urban%20alleyway%20and%20neon%20reflections%2C%20noir%20cinematography%20style%2C%20rain%20on%20pavement%2C%20warm%20streetlamp%20glow%2C%20suspenseful%20mood&width=800&height=450&seq=carousel-02&orientation=landscape',
  },
  {
    id: 3,
    title: '古装仙侠 · 东方奇幻盛宴',
    subtitle: '特效升级 · 视觉革命',
    description: '精美服化道配合顶级特效团队，《长相思2》《与凤行》《狐妖小红娘》真人版，每一帧都是壁纸级别的视觉享受。',
    tag: '仙侠',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20drama%20scene%20with%20floating%20mountains%20and%20misty%20waterfalls%2C%20traditional%20silk%20robes%20flowing%20in%20wind%2C%20soft%20golden%20sunlight%20through%20clouds%2C%20celestial%20palace%20in%20distance&width=800&height=450&seq=carousel-03&orientation=landscape',
  },
  {
    id: 4,
    title: '都市情感 · 现实主义力作',
    subtitle: '真实扎心 · 引发共鸣',
    description: '聚焦当代都市生活，《三十而已2》《都挺好2》《我在他乡挺好的》姐妹篇，用最真实的故事打动最真的你。',
    tag: '都市',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20scene%20with%20city%20skyline%20at%20sunset%2C%20warm%20apartment%20interior%20lighting%2C%20cozy%20living%20room%20with%20soft%20amber%20glow%2C%20emotional%20storytelling%20atmosphere&width=800&height=450&seq=carousel-04&orientation=landscape',
  },
  {
    id: 5,
    title: '经典老剧修复重映专题',
    subtitle: '高清修复 · 重温经典',
    description: '《甄嬛传》《琅琊榜》《大明王朝1566》等经典之作4K修复版上线，画质升级，情怀不变，与千万剧迷一起重温。',
    tag: '经典',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20classic%20drama%20collection%20display%2C%20ornate%20traditional%20scrolls%20and%20ancient%20artwork%2C%20warm%20museum%20gallery%20lighting%2C%20golden%20and%20burgundy%20color%20palette%2C%20nostalgic%20elegant%20composition&width=800&height=450&seq=carousel-05&orientation=landscape',
  },
];

export const comments = [
  { id: 1, name: '追剧少女小王', avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20female%20avatar%20with%20warm%20smile%2C%20soft%20pastel%20colors%2C%20modern%20illustration%2C%20simple%20background&width=80&height=80&seq=avatar-01&orientation=squarish', rating: 5, time: '2小时前', content: '四虎影视大全真的太良心了！更新速度超快，《长安十二时辰2》刚播完就能看到全集，画质也很清晰，强烈推荐给所有喜欢追剧的朋友！' },
  { id: 2, name: '老张说剧', avatar: 'https://readdy.ai/api/search-image?query=Simple%20male%20avatar%20illustration%20with%20glasses%2C%20warm%20friendly%20expression%2C%20clean%20minimal%20style%2C%20neutral%20background&width=80&height=80&seq=avatar-02&orientation=squarish', rating: 5, time: '5小时前', content: '作为资深剧评人，四虎影视的片源质量在同类平台中绝对数一数二。分类清晰，搜索方便，不用到处找资源，一个站就够了。' },
  { id: 3, name: '夜猫子追剧人', avatar: 'https://readdy.ai/api/search-image?query=Cool%20modern%20illustration%20female%20avatar%20with%20headphones%2C%20dark%20hair%2C%20creative%20style%2C%20simple%20background&width=80&height=80&seq=avatar-03&orientation=squarish', rating: 4, time: '8小时前', content: '界面简洁没有烦人广告，体验很舒服。唯一的建议是希望能多上线一些韩剧和日剧资源，国产剧这块已经非常全了。' },
  { id: 4, name: '影视达人阿杰', avatar: 'https://readdy.ai/api/search-image?query=Stylish%20male%20avatar%20illustration%20with%20beanie%20hat%2C%20casual%20cool%20vibe%2C%20warm%20tones%2C%20simple%20background&width=80&height=80&seq=avatar-04&orientation=squarish', rating: 5, time: '12小时前', content: '朋友推荐的四虎影视大全，用了三个月了，这个站真的太稳了。全集资源丰富，热门新剧基本都能找到，已经安利给身边所有人。' },
  { id: 5, name: '周末追剧党', avatar: 'https://readdy.ai/api/search-image?query=Cozy%20female%20avatar%20illustration%2C%20reading%20theme%2C%20warm%20comfy%20style%2C%20soft%20colors%2C%20simple%20background&width=80&height=80&seq=avatar-05&orientation=squarish', rating: 5, time: '1天前', content: '每周末必刷四虎影视大全，已经成了生活习惯。希望平台越做越好，多上线一些独家内容，会一直支持下去的！' },
];

export const updates = [
  { id: 1, date: '2026.08.01', label: '剧集上线', title: '《长安十二时辰2》全集正式上线', description: '年度最受期待古装大剧终于来了，全48集一次放出，高清画质畅快追剧。' },
  { id: 2, date: '2026.07.30', label: '系统升级', title: '播放引擎全面升级，加载速度提升300%', description: '全新CDN加速节点部署完成，4K画质秒加载，追剧体验再上新台阶。' },
  { id: 3, date: '2026.07.28', label: '新剧预告', title: '《大江大河4》定档8月15日首播', description: '正午阳光出品，王凯、杨烁主演，改革开放题材史诗巨制，敬请期待。' },
  { id: 4, date: '2026.07.25', label: '功能更新', title: '智能追剧提醒功能上线', description: '不再错过任何更新！订阅心仪剧集，更新第一时间推送通知，追剧零延迟。' },
  { id: 5, date: '2026.07.22', label: '专题上线', title: '「谍战风云」经典谍战剧专题上线', description: '《潜伏》《悬崖》《风筝》《伪装者》等20部经典谍战剧高清合集，一次看够。' },
  { id: 6, date: '2026.07.18', label: '剧集上线', title: '《狐妖小红娘》真人版全集上线', description: '顶级玄幻IP改编，杨幂、龚俊领衔主演，特效震撼，剧情还原，口碑爆棚。' },
  { id: 7, date: '2026.07.15', label: '平台公告', title: '四虎影视大全用户突破5000万', description: '感谢每一位剧迷的支持与信任，我们将持续提供最优质的免费全集观看服务。' },
];

export const topics = [
  { id: 1, name: '长安十二时辰2', heat: '986万', trend: 'up' },
  { id: 2, name: '长相思第二季', heat: '872万', trend: 'up' },
  { id: 3, name: '狐妖小红娘真人版', heat: '765万', trend: 'up' },
  { id: 4, name: '大江大河4', heat: '698万', trend: 'new' },
  { id: 5, name: '与凤行', heat: '654万', trend: 'stable' },
  { id: 6, name: '悬疑剧场', heat: '589万', trend: 'up' },
  { id: 7, name: '古装仙侠', heat: '543万', trend: 'stable' },
  { id: 8, name: '谍战风云', heat: '498万', trend: 'up' },
  { id: 9, name: '经典老剧修复', heat: '432万', trend: 'up' },
  { id: 10, name: '暑期档追剧指南', heat: '387万', trend: 'new' },
];

export const rankingItems = [
  { rank: 1, title: '长安十二时辰2', type: '古装悬疑', heat: '986万', change: 'new' },
  { rank: 2, title: '长相思第二季', type: '古装仙侠', heat: '872万', change: 'up' },
  { rank: 3, title: '狐妖小红娘', type: '玄幻爱情', heat: '765万', change: 'up' },
  { rank: 4, title: '白夜追凶3', type: '悬疑犯罪', heat: '723万', change: 'up' },
  { rank: 5, title: '三十而已2', type: '都市情感', heat: '689万', change: 'down' },
  { rank: 6, title: '与凤行', type: '古装仙侠', heat: '654万', change: 'stable' },
  { rank: 7, title: '都挺好2', type: '家庭伦理', heat: '598万', change: 'up' },
];

export const features = [
  {
    id: 1,
    icon: 'ri-movie-2-line',
    title: '海量片库 · 每日更新',
    description: '收录超过8000部国产电视剧完整全集，涵盖古装、悬疑、都市、仙侠、谍战等全品类。每日同步更新最新上线剧集，不错过任何一部好剧。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清画质 · 流畅播放',
    description: '全站采用H.265编码技术，支持1080P至4K超清画质。智能CDN加速，根据网络环境自适应码率，保证每一秒都流畅无卡顿。',
  },
  {
    id: 3,
    icon: 'ri-shield-check-line',
    title: '安全纯净 · 免费观看',
    description: '全站无弹窗广告、无强制注册、无恶意跳转。所有剧集完全免费，以优质体验回馈每一位剧迷，让追剧回归纯粹快乐。',
  },
];

export const faqItems = [
  {
    id: 1,
    question: '四虎影视大全需要付费吗？',
    answer: '完全不需要！四虎影视大全所有电视剧全集均为免费提供，无需注册、无需会员、无需支付任何费用。我们致力于为剧迷提供最纯粹的免费观影体验。',
  },
  {
    id: 2,
    question: '剧集更新速度怎么样？新剧多久能上线？',
    answer: '我们的更新团队7×24小时不间断工作，热门新剧通常在首播后2-4小时内完成全集上线。部分头部大剧可实现与卫视同步更新，让你第一时间追到最新内容。',
  },
  {
    id: 3,
    question: '支持哪些设备观看？有App吗？',
    answer: '四虎影视大全全面支持PC、平板、手机等主流设备访问，网页端自适应适配，无需下载App即可获得优秀观影体验。移动端入口请查看本页「手机看片」专区。',
  },
  {
    id: 4,
    question: '画质怎么样？能看高清吗？',
    answer: '全站默认提供1080P高清画质，部分热门剧集支持4K超清。采用智能码率自适应技术，根据您的网络状况自动匹配最佳画质，确保流畅播放不卡顿。',
  },
  {
    id: 5,
    question: '如果遇到播放问题怎么办？',
    answer: '如遇播放卡顿或加载失败，建议尝试以下方式：1）刷新页面重试；2）切换网络环境；3）通过「联系我们」专区反馈具体问题。我们的技术团队会第一时间处理。',
  },
];

export const indexItems = [
  { id: 1, title: '古装仙侠专题', count: '326部', description: '从经典到新作，仙侠世界一网打尽', icon: 'ri-cloud-line' },
  { id: 2, title: '悬疑推理合集', count: '218部', description: '烧脑不断，反转不停', icon: 'ri-search-eye-line' },
  { id: 3, title: '都市情感剧场', count: '295部', description: '都市百态，人情冷暖', icon: 'ri-building-line' },
  { id: 4, title: '谍战风云录', count: '156部', description: '潜伏暗战，惊心动魄', icon: 'ri-spy-line' },
  { id: 5, title: '历史正剧典藏', count: '187部', description: '还原历史，致敬经典', icon: 'ri-ancient-gate-line' },
  { id: 6, title: '喜剧爆笑合集', count: '243部', description: '欢乐不断，解压神器', icon: 'ri-emotion-laugh-line' },
  { id: 7, title: '经典老剧修复', count: '412部', description: '4K重现，经典永恒', icon: 'ri-refresh-line' },
];

export const aboutInfo = {
  title: '关于四虎影视大全',
  description: '四虎影视大全创立于2020年，是国内领先的免费电视剧全集在线观看平台。我们专注于为华语剧迷提供最新最全的电视剧资源，覆盖古装、悬疑、都市、仙侠、谍战等全品类内容。平台始终坚持免费、纯净、安全的运营理念，不设置任何付费门槛，以优质的用户体验和极速的更新速度赢得超过5000万剧迷的信赖。我们的内容团队每日追踪全网最新剧集动态，确保每一部好剧都能第一时间呈现给观众。',
  stats: [
    { label: '收录剧集', value: '8000+' },
    { label: '每日更新', value: '50+' },
    { label: '活跃用户', value: '5000万+' },
    { label: '运营年限', value: '6年' },
  ],
};

export const cardsItems = [
  {
    id: 1,
    title: '《长安十二时辰2》—— 年度古装悬疑天花板',
    description: '雷佳音、易烊千玺原班人马回归，剧情升级，制作规模翻倍。48集完整版已上线，豆瓣开分9.1，今年最不能错过的国产剧。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20drama%20scene%20with%20ancient%20city%20at%20night%2C%20lanterns%20and%20torches%2C%20guards%20in%20traditional%20armor%2C%20dramatic%20cinematic%20lighting%2C%20warm%20amber%20and%20gold%20tones&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '热播推荐',
  },
  {
    id: 2,
    title: '《白夜追凶3》—— 国产悬疑剧巅峰回归',
    description: '潘粤明再度一人分饰两角，案件更加离奇，真相更加扑朔迷离。32集全集已更新完毕，准备好你的推理大脑了吗？',
    image: 'https://readdy.ai/api/search-image?query=Dark%20crime%20drama%20scene%20with%20rainy%20city%20street%2C%20detective%20silhouette%20under%20streetlamp%2C%20mysterious%20atmosphere%2C%20noir%20cinematography%2C%20cool%20blue%20and%20warm%20amber%20contrast&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '口碑神作',
  },
  {
    id: 3,
    title: '《狐妖小红娘》真人版 —— 玄幻IP改编新标杆',
    description: '杨幂、龚俊倾情演绎，月红篇特效炸裂，剧情高度还原原著。豆瓣8.7分口碑认证，玄幻剧爱好者不可错过。',
    image: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20romance%20drama%20scene%20with%20cherry%20blossoms%20and%20magical%20glowing%20auras%2C%20beautiful%20traditional%20costumes%2C%20soft%20pink%20and%20golden%20lighting%2C%20dreamy%20atmosphere&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '仙侠大作',
  },
  {
    id: 4,
    title: '《大江大河4》—— 时代浪潮中的奋斗者之歌',
    description: '正午阳光金牌团队打造，王凯、杨烁、董子健主演。定档8月15日，改革开放进入深水区，宋运辉们的新故事即将展开。',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20reform%20era%20drama%20scene%20with%20factory%20and%20industrial%20landscape%2C%20vintage%201990s%20aesthetic%2C%20warm%20nostalgic%20tones%2C%20hardworking%20characters%20in%20period%20clothing&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '即将上线',
  },
  {
    id: 5,
    title: '《三十而已2》—— 都市女性成长新篇章',
    description: '江疏影、童瑶、毛晓彤再度携手，聚焦35+女性新困境。真实、扎心、治愈，每一个都市女性都能从中看到自己。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20urban%20drama%20with%20three%20women%20in%20fashionable%20city%20apartment%2C%20warm%20evening%20light%20through%20floor%20to%20ceiling%20windows%2C%20cozy%20contemporary%20interior%2C%20emotional%20connection&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '都市情感',
  },
  {
    id: 6,
    title: '《与凤行》—— 赵丽颖林更新再续仙侠情缘',
    description: '九鹭非香同名小说改编，顶级制作团队倾力打造。39集全集已上线，画面美到每一帧都可以截屏当壁纸。',
    image: 'https://readdy.ai/api/search-image?query=Mythical%20Chinese%20fantasy%20drama%20with%20phoenix%20motif%2C%20celestial%20beings%20in%20flowing%20silk%20robes%2C%20heavenly%20palace%20courtyard%2C%20golden%20and%20crimson%20color%20palette%2C%20epic%20cinematic%20scale&width=600&height=400&seq=card-06&orientation=landscape',
    tag: '全集上线',
  },
  {
    id: 7,
    title: '谍战经典合集 —— 重温那些暗流涌动的岁月',
    description: '《潜伏》《悬崖》《风筝》《伪装者》等20部经典谍战剧4K修复版，一次看尽中国谍战剧发展史。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20Chinese%20spy%20drama%20aesthetic%20with%20old%20Shanghai%20street%20scene%2C%20shadowy%20figures%20in%20trench%20coats%2C%20retro%20telephone%20and%20typewriter%2C%20sepia%20and%20warm%20brown%20tones&width=600&height=400&seq=card-07&orientation=landscape',
    tag: '经典合集',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '《长安十二时辰2》终极预告',
    duration: '02:35',
    views: '1286万',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20historical%20action%20drama%20trailer%20moment%2C%20intense%20battle%20scene%20with%20fire%20arrows%2C%20dramatic%20cinematic%20lighting%2C%20ancient%20Chinese%20city%20at%20night%2C%20movie%20poster%20quality&width=560&height=315&seq=media-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《大江大河4》先导片花',
    duration: '01:48',
    views: '967万',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20Chinese%20industrial%20era%20drama%20trailer%20moment%2C%20steel%20factory%20interior%20with%20sparks%2C%20determined%20worker%20silhouette%2C%20golden%20hour%20lighting%2C%20inspirational%20cinematic%20style&width=560&height=315&seq=media-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《狐妖小红娘》精彩花絮',
    duration: '03:12',
    views: '845万',
    image: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20Chinese%20fantasy%20drama%20with%20actors%20in%20elaborate%20costumes%2C%20green%20screen%20studio%2C%20professional%20film%20crew%2C%20warm%20set%20lighting%2C%20candid%20moments&width=560&height=315&seq=media-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《三十而已2》情感特辑',
    duration: '04:20',
    views: '723万',
    image: 'https://readdy.ai/api/search-image?query=Emotional%20Chinese%20urban%20drama%20interview%20scene%2C%20actress%20with%20tearful%20expression%20in%20soft%20window%20light%2C%20intimate%20closeup%2C%20warm%20natural%20tones%2C%20cinematic%20shallow%20depth%20of%20field&width=560&height=315&seq=media-04&orientation=landscape',
  },
];

export const navSections = [
  { href: '#faq', label: '常见问题' },
  { href: '#cards', label: '精选推荐' },
  { href: '#app', label: '手机看片' },
  { href: '#comments', label: '剧迷热评' },
];